import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2021-09-24'
        tag='Poshmark'
        title='Poshmark vs Tradesy 2021 - What is Best for Sellers?'
      >
        <p>
          There’s no doubt the recent year has been tough for some industries, but it is safe to say that e-commerce or
          social commerce is not one of them. Online shopping, even before the pandemic hit, is a booming business for
          the convenience it offers consumers. Virtual marketplaces and boutiques all the more became relevant and
          appealing to consumers cooped up at home as it promotes a safe shopping experience.{' '}
        </p>

        <p>
          When it comes to pre-owned clothing and personal items, buyers are spoilt for choice. There’s a wide array of
          online marketplaces and resale sites available to scour for practically every item they might have in mind or
          fancy. From peer-to-peer resell marketplaces (Poshmark, Mercari, Tradesy), consignment marketplaces, thrift
          stores (ThredUP, RealReal), to the more established, traditional channels (eBay, Amazon), even sellers might
          find it challenging to decide on a selling platform.{' '}
        </p>

        <p>
          To help in finding the right fit, consider the platform’s customer base, the fees involved, the shipping
          options, how they protect sellers, and the factors that contribute to seller success. In this article, we will
          be focusing on Poshmark and Tradesy. If you’re interested in Mercari and ThredUP, do read our articles about
          them here and here.
        </p>

        <h3>
          <i>Customer Base</i>
        </h3>

        <h3>Poshmark</h3>

        <p>
          Touted as a “Vibrant community powered by millions of sellers,” Poshmark is one of the key players and
          top-of-mind platforms in the online marketplace scene with over 70 million community members in the United
          States, Canada, and Australia. Its decade-long industry experience has enabled it to continuously improve the
          platform with new features and to strengthen its positioning within its market composed of women and men who
          are mostly Gen Z and Millennials – social-media-savvy demographics that thrive on Poshmark’s dynamic
          environment.{' '}
        </p>

        <p>
          The platform boasts a listing of approximately 200 million items, a combination of new and secondhand, across
          a broad range of categories. Here, items for both women and men, as well as kids’ clothing, are available.
          Certain items for pets and the home, and for beauty and wellness (including brand new makeup) are also
          allowed. Poshmark is not for those planning to sell electronics or used personal care items or other items
          under their restricted categories.
        </p>

        <p>
          Consistent with the wide array of categories is the range of brands available on Poshmark closets. Buyers go
          for a mix of fast-fashion brands, popular sportswear labels like Nike and Adidas, and some labels from the
          higher end of the spectrum like Gucci or Tory Burch.{' '}
        </p>

        <p>
          As of the moment, selling and buying in Poshmark is available only for those located and residing in the
          United States, Canada, and Australia.{' '}
        </p>

        <h3>Tradesy</h3>

        <p>
          Officially launched in 2012 as an online fashion marketplace “built by and for women,” Tradesy is the largest
          peer-to-peer luxury platform in the United States. It has a straightforward product offering (designer items
          only, either brand new or secondhand) and a concentrated customer base (women), which makes it an ideal
          platform for those in the business of selling only guaranteed authentic luxury items for women.
        </p>

        <p>
          This platform is known for handbags, jewelry and accessories, shoes, and designer clothing from luxury labels
          like Louis Vuitton, Chanel, Prada, and Christian Louboutin. It also carries mid-range brands like Zara, J.
          Crew, and Lululemon, from which the bestselling clothing items come from.{' '}
        </p>

        <p>
          What’s also distinct about Tradesy is its selection of wedding items, from bridal gowns to everything one
          might need for a wedding either as a bride, part of the entourage, or a guest looking for the perfect gift.
          Sellers who have some elegant pairs of shoes or high-value evening dresses worn only once or twice and are now
          left forgotten at the back of your closet, might have better chances of selling them for a good price on
          Tradesy.
        </p>

        <p>
          On the other hand, this platform is not for those planning to offer men’s items (except for watches and
          wallets), unbranded old clothes, fragrances and cosmetics, health and beauty products, swimwear, electronics,
          and kid’s clothing.{' '}
        </p>

        <p>
          To list on Tradesy, sellers must be located and residing in the United States. Buyers, on the other hand, can
          come from any part of the world as long as they’re willing to shoulder the corresponding international
          shipping fees.
        </p>

        <h3>
          <i>The Fees</i>
        </h3>

        <h3>Poshmark</h3>

        <p>
          There’s no listing fee on Poshmark. Sellers have the freedom to list as many items as possible, and will only
          be charged once an item sells. The listing price of the item dictates the type of charge it will be subjected
          to. Poshmark classifies its fees into two types only: Either a single flat rate or a fixed commission rate.
          There are no transaction fees or any additional or hidden charges.{' '}
        </p>

        <p>For transactions involving items worth less than $15, Poshmark takes $2.95. </p>
        <p>For transactions involving items worth more than $15, Poshmark takes 20% of the listing price.</p>
        <p>
          In return, sellers get to enjoy a seamless selling experience, as the platform will handle the financial
          nitty-gritty such as credit card fees and sales taxes; provide pre-addressed and prepaid shipping labels; lend
          customer support; and provide sellers’ protection.{' '}
        </p>

        <p>
          This simple commission framework makes it easy for sellers to determine the listing price for each item. They
          just need to set listing prices that will allow them to pocket healthy profits even after the corresponding
          Poshmark fees have been applied. They can also easily refer to this as a guide in helping them decide whether
          or not to accept a potential buyer’s offer, or how low to drop the prices when they are offering discounts.{' '}
        </p>

        <p>
          Sellers’ earnings are credited on their Posh account, which can be used to purchase from fellow Poshers, or
          directly deposited into their bank account.{' '}
        </p>

        <h3>Tradesy</h3>

        <p>
          Likewise, an unlimited listing is free on Tradesy. Its commission framework is also quite similar to Poshmark,
          but it is a bit more complicated because the earnings would also depend on the shipping method chosen by the
          seller.{' '}
        </p>

        <p>For transactions involving items worth less than $50, Tradesy charges a flat commission fee of $7.50. </p>
        <p>For transactions involving items worth more than $50, Tradesy pockets a 19.8% commission. </p>
        <p>These are the three shipping options:</p>
        <ul>
          <li>
            <b>Ship using a Tradesy Shipping Kit or a pre-paid shipping label</b> – Tradesy will add the shipping fee on
            top of the selling price, and together these will show up as the listing price. The corresponding commission
            fee will be deducted based on the selling price.
          </li>
          <li>
            <b>Ship using your shipping</b> – The seller will factor in the estimated out-of-pocket shipping fee in
            setting the listing price of an item. Tradesy will then deduct the corresponding commission fee based on the
            listing price.
          </li>
          <li>
            <b>Sell during a Tradesy Sales or Promotion</b> – If the seller opts in for any sales or promotional event,
            the deduction will be based on the final discounted price for which the item sold. To better manage sellers’
            expectations and let them adjust their prices as necessary, the breakdown of the projected earnings and
            commission is shown before the listing goes live. It’s important to note that the earnings breakdown also
            includes the 2.9% Safe Transfer Fee, which is automatically factored in whenever a seller lists an item.
            Tradesy charges this additional, mandatory fee to cover the fees incurred in processing the payment.
          </li>
        </ul>
        <p>
          After each successful sale, the earnings will reflect on the seller’s account where it serves as good as cash
          in snapping up a new luxury item on the platform. Otherwise, it can be transferred to the seller’s PayPal,
          checking account, or debit card.{' '}
        </p>

        <h3>
          <i>Shipping</i>
        </h3>

        <h3>Poshmark</h3>

        <p>
          Shipping costs may be used as leverage in strategizing as a seller on Poshmark. There is the option to make an
          item irresistible to buyers by offering free shipping, to position a discounted shipping as a freebie when a
          buyer purchases two or more items, or to set a competitive listing price and let the buyer shoulder the flat
          rate USPS shipping cost at $7.45 for a package no heavier than 5lbs. Poshmark will provide the shipping label,
          but it is the seller’s responsibility to make sure the correct box is used (USPS Priority Mail for US orders)
          and that the package is dispatched within two to three days of purchase.{' '}
        </p>

        <p>
          In case of returns, Poshmark will shoulder the shipping of the item back to the seller if the cause is proven
          valid under the Poshmark Return Policy. A full refund shall also be awarded to the buyer.{' '}
        </p>

        <h3>Tradesy</h3>

        <p>
          The three shipping options mentioned above are available for all listings, except for items under the Wedding
          category wherein sellers must take care of shipping.{' '}
        </p>

        <p>
          Sellers who opt for a free shipping kit (buyer shoulders the shipping fee) will receive it within three to
          five days of the Order Date. The kit includes a pre-paid USPS label with tracking and must be filled with the
          purchased item and mailed to the buyer within 10 days from the Order Date.{' '}
        </p>

        <p>
          Returns are likewise handled by Tradesy at no cost to the seller and buyer. It also covers the shipping costs
          incurred when a buyer reports a suspected counterfeit item that needs to undergo an authentication check by
          their team of experts. Since Tradesy specializes in luxury items, it upholds a policy of Zero Tolerance to
          Fraud. Shipping and other expenses will be extracted from the Tradesy account of the seller found guilty of
          retailing a replica or misrepresented an item.{' '}
        </p>

        <h3>
          <i>Seller Protection</i>
        </h3>

        <h3>Poshmark</h3>

        <p>
          To be covered by Poshmark in case of loss of package, sellers must use the shipping label provided by Poshmark
          and have the package scanned into the USPS tracking system for visibility. Buyers will be notified of the
          delivery (orders worth $400 and up will require a signature) and be prompted to review and accept the order
          within three days. Otherwise, they can open a claim for a return request. Sellers are encouraged to respond
          promptly and with sufficient documentation to help defend their case. Poshmark will then review the case and
          come up with a fair resolution.{' '}
        </p>

        <p>
          Helpful resources like its in-house blog also somehow add to the Poshmark sellers’ confidence and contribute
          to their sense of protection while using the platform.{' '}
        </p>

        <h3>Tradesy</h3>

        <p>
          Tradesy seller protection is not clearly and sufficiently discussed on their website, unlike Poshmark.
          Instances like delayed or missing shipment may be reported to the Tradesy team by email or phone. Buyers
          unhappy with their purchases can file a claim for return within four days. Returned items to the seller may be
          relisted on the platform.{' '}
        </p>

        <h3>
          <i>Effort as Seller</i>
        </h3>

        <p>
          Sellers are guided every step of listing an item. There are prompts to ensure your description is complete and
          accurate, cues to help sellers set the right price, and a feature that lets sellers enhance their own photos
          to make them appealing to buyers and at par with Tradesy’s luxe look and feel.{' '}
        </p>

        <p>
          When it comes to boosting sales and promoting one’s listings, Tradesy offers sellers minimal opportunities.
          There’s the Smart Pricing feature that sellers could opt-in for all or specific items on their closet. This
          helps optimize an item’s price by gradually reducing it by 10% week after week until it gets sold or until it
          reaches the floor price set by the seller. The participating items will get a chance to show up more on users’
          feeds with an “On Sale” badge. Promotion is limited to sharing a seller’s personalized link on Facebook or
          directly to prospective buyers.
        </p>

        <p>
          Tradesy is ideal for sellers who are fine with letting their items sit idly on the site, alongside
          competition, while waiting for their chance to be organically discovered by interested buyers.{' '}
        </p>

        <p>
          On the other hand, Poshmark is for sellers who enjoy working in a fast-paced environment and bustling
          community. Here, a seller’s chance of making a sale hinge on how actively and consistently she shares her
          closet, as well as other Poshers’ listings, in a day and how she takes advantage of opportunities to sell and
          network, like joining Posh Parties and Posh Fest. Becoming a Posh Ambassador also helps, if the seller is
          willing to put in the time and effort to achieve that status.{' '}
        </p>

        <p>
          Some tasks that contribute to seller success on Poshmark do require time and effort but can be automated:
          Sharing, growing followers and following back, sending offers, and more. OneShop helps sellers list to both
          marketplaces, getting the best of both! Try OneShop, an intelligent assistant designed to do the work even as
          you sleep. Register for a 7-day free trial to see if it’s a good fit with your business!
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
